<template>
  <accounts-component-template
    component-name="Translation Review Management"
    component-key="translation-review"
    color="#7DB8D3">
    <template v-slot:icon>
      <calendar-check-icon :size="16" />
    </template>
    <template v-slot:content>
      <div class="account-details-formfield">
        <label class="account-details-checkboxfield clickable">
          <input type="checkbox" v-model="translationReviewEnabled" />
          <span>Enable Translation Review Management</span>
        </label>
        <p style="padding-left:24px">When enabled, client users will be able to see the Review menu item, manage reviewers and create review tasks.</p>
      </div>
    </template>
  </accounts-component-template>
</template>

<script>
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import {CalendarCheckIcon} from '../icons';
import {mapActions, mapGetters} from 'vuex';

export default {

  props: {},

  components: {
    AccountsComponentTemplate,
    CalendarCheckIcon,
  },

  data () {
    return {}
  },

  computed: {

      ...mapGetters('AdminAccountDetailsStore', [
          'trmSettings',
          'accountId'
      ]),

      translationReviewEnabled: {

          get () {
              return this.trmSettings.isEnabled;
          },

          set (value) {
            console.log('checked value', value)
              this.setTranslationReviewEnabled(value);
          }
      }
  },

  methods: {

    ...mapActions('AdminAccountDetailsStore', [
       'updateTranslationReviewStatus'
    ]),

    setTranslationReviewEnabled (isEnabled) {
        this.updateTranslationReviewStatus({
            accountId: this.accountId,
            isEnabled: isEnabled
        }).then(result => {
            if (!result) {
                console.error('trm update error');
            }
        })
    }
  }
}
</script>
